module.exports = __webpack_public_path__ + "static/media/howSection2Image1.15e94484.gif";